import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react'; 

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-2 right-5 z-[1000]">
      {/* Floating Chatbot Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition-all duration-300 ease-in-out"
        aria-label="Toggle Chatbot"
      >
        <MessageCircle className="w-6 h-6" />
      </button>

      {/* Chatbot Panel */}
      {isOpen && (
        <div className="mt-4 w-[1200px] h-[730px] overflow-auto transition-all duration-300 ease-in-out">
          <iframe
            src="https://chat.yslearn.in"
            title="Chatbot"
            className="w-full h-full border-none rounded-2xl"
          />
        </div>
      )}
    </div>
  );
};

export default ChatbotWidget;
